import { ThemeProvider, createTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/Card": Card, "@mui/material/CardContent": CardContent, "@mui/material/CardActions": CardActions, "@mui/material/Alert": Alert, "@mui/material/Button": Button } } });
export default ClientProvider;
